<template>
  <div class="sm-customers__main-empty">
    <template v-if="!$route.query.search">
      <h5>No {{userText}}s yet</h5>
      <p>Added {{userText}}s displayed here</p>
      <a
        href="#"
        @click.prevent="$emit('new')"
      >
        <include-svg :name="'icon-plus'" />
        <span>Add first {{userText}}</span>
      </a>
    </template>
    <template v-else>
      <h5>No {{userText}}s found</h5>
      <a
        href="#"
        @click.prevent="$emit('new')"
      >
        <include-svg :name="'icon-plus'" />
        <span>Add {{userText}}</span>
      </a>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'empty-customers-table',
  computed: {
    ...mapGetters({
      provider: 'provider'
    }),
    userText() {
      return this.provider.client_level != 1 ? 'customer' : 'user';
    }
  }
}
</script>